import { HttpLink, from } from '@apollo/client';
import { featureFlagClient } from '@trello/feature-flag-client';
import { trelloRequiredHeadersLink } from './trelloRequiredHeadersLink';

// eslint-disable-next-line @trello/no-module-logic
export const trelloHttpLink = from([
  trelloRequiredHeadersLink,
  new HttpLink({
    credentials: 'include',
    uri: (operation) => {
      const operationNamesEnabled = featureFlagClient.get(
        'fep.operation-name-in-url',
        false,
      );

      // We include the "operationName" parameter purely for debugging. This should never infer behavior or be relied
      // upon by the server.
      return !operationNamesEnabled || !operation.operationName
        ? '/graphql'
        : `/graphql?operationName=${operation.operationName}`;
    },
  }),
]);
